// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"IconButton_IconButton__SVHGG"};